import React from "react";
import "../Styles-css/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-tag">Kiraya Wala</h3>
          <p className="foooter-p">Specializing in connecting tenants with landlords, we offer a seamless and efficient platform for finding rental properties.
          Whether you're looking for an apartment, house, or commercial space, our extensive listings ensure you find the perfect place to call home.
                
          </p>
        </div>
        <div className="footer-section">
          <h3 className="footer-tag">Get In Touch</h3>
          <p className="foooter-p">Add:- Z-15 First Floor Sheela Arcade<br /> 
                  Near HDFC Bank Zone-1 MP Nagar <br />
                  Bhopal, Madhya Pradesh </p>
          <p className="foooter-p">Call:- +91 7898622741</p> 
          </div>

        <div className="footer-section">
          <h3 className="footer-tag">Quick Links</h3>
          <ul>
            <li><a href="home">Home</a></li>
            <li><a href="about">About Us</a></li>
            <li><a href="service">Our Services</a></li>
            <li><a href="contact">Contact Us</a></li>
            <li><a href="policy">Privacy Policy</a></li>
            <li><a href="terms">Terms & Conditions</a></li>
            <li><a href="cancellationPolicy">Cancellation Policy</a></li>

          </ul>
        </div>
      
        <div className="footer-section">
          <h3 className="footer-tag">More Information</h3>
          <p className="foooter-p">From budget-friendly rentals to premium homes for purchase, KirayaWala has something for everyone—your dream home is just a step away.</p>
          <div className="newsletter">
            <p className="foooter-p">Email:- indiakirayawala@gmail.com</p>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© <a href="#">KirayaWala</a>, All Rights Reserved. Designed by <a href="#">Khushi</a></p>
        <div className="footer-social-bottom">
          <a href="https://wa.me/message/S75PHV2OQNM3P1" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-whatsapp"></i>
          </a>
          <a href="https://facebook.com/yourpage" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/indiakirayawala?igsh=N253ZWZ2aGx0ZHZm" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://x.com/Kiraya_Wala?t=s-h3K2Xk1fs-e_c09SXVbQ&s=08" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://t.me/+917898622741" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-telegram-plane"></i>
          </a>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;
